import { Grid } from "lucide-react";

import AttendanceTileDesign from "../../platforms/campus/tiles/Attendance/TileDesign";
import CommunicationTileDesign from "../../platforms/campus/tiles/Communication/TileDesign";
import EnrollmentTileDesign from "../../platforms/campus/tiles/Enrollment/TileDesign";
import StaffTileDesign from "../../platforms/campus/tiles/Staff/TileDesign";
import StudentsTileDesign from "../../platforms/campus/tiles/Students/TileDesign";
import TuitionTileDesign from "../../platforms/campus/tiles/Tuition/TileDesign";
import TestingHubTileDesign from "../../platforms/edu/tiles/TestingHub/TileDesign";
import GlobalUsersTileDesign from "../../platforms/admin/tiles/GlobalUsers/TileDesign";
import EduTestingAppsTileDesign from "../../platforms/admin/tiles/EduTestingApps/TileDesign";
import TileStoreManagerTileDesign from "../../platforms/admin/tiles/TileStoreManager/TileDesign";

/**
 * =========================================
 * GLOBAL TILE DESIGN REGISTRY
 * =========================================
 */

/* =========================
   🔥 DEFAULT / FALLBACK TILE
========================= */
const DefaultTileDesign = {
  id: "default",
  icon: Grid,
  label: "App",
  background: "#6B7280",
  color: "#ffffff",
};

/* =========================
   🔥 STORE TILE
========================= */
const StoreTileDesign = {
  id: "store",
  icon: Grid,
  label: "Tile Store",
  background: "#2F6EA3",
  color: "#ffffff",
};

export const tileDesign = {
  /* SYSTEM */
  [StoreTileDesign.id]: StoreTileDesign,

  /* APP TILES */
  [AttendanceTileDesign.id]: AttendanceTileDesign,
  [CommunicationTileDesign.id]: CommunicationTileDesign,
  [EnrollmentTileDesign.id]: EnrollmentTileDesign,
  [StaffTileDesign.id]: StaffTileDesign,
  [StudentsTileDesign.id]: StudentsTileDesign,
  [TuitionTileDesign.id]: TuitionTileDesign,
  [TestingHubTileDesign.id]: TestingHubTileDesign,
  [GlobalUsersTileDesign.id]: GlobalUsersTileDesign,
  [EduTestingAppsTileDesign.id]: EduTestingAppsTileDesign,
  [TileStoreManagerTileDesign.id]: TileStoreManagerTileDesign,
};

/* SAFE GETTER */
export const getTileDesign = (id) => {
  return tileDesign[id] || DefaultTileDesign;
};
